import React from 'react';
import styled from 'styled-components';

import { FreeCodeBlockData } from 'api/cms';
import { RichText } from 'components/Text';
import emailSignupBlock from 'utils/styles/emailSignupBlock';

const StyledRichText = styled(RichText)`
  ${emailSignupBlock}
`;

type Props = {
  data: FreeCodeBlockData;
};

export function FreeCodeBlock({ data: { code } }: Props) {
  return (
    <StyledRichText
      dangerouslySetInnerHTML={{
        __html: code,
      }}
      tag="section"
    />
  );
}
